import { type ReactElement } from 'react'
import { WeekdaySchema, type Weekday } from '@terros/common'
import { Select } from '@mantine/core'
import { type WithProgramForm } from './type'

const WEEKDAY_OPTIONS: { value: string; label: string }[] = [
  { value: 'none', label: 'None' },
  { value: 'sun', label: 'Sunday' },
  { value: 'mon', label: 'Monday' },
  { value: 'tue', label: 'Tuesday' },
  { value: 'wed', label: 'Wednesday' },
  { value: 'thu', label: 'Thursday' },
  { value: 'fri', label: 'Friday' },
  { value: 'sat', label: 'Saturday' },
]

const getWeekdayValue = (startWeekday: Weekday | null | undefined): string => startWeekday ?? 'none'

export const ProgramStartWeekday = ({ form }: WithProgramForm): ReactElement => {
  const handleChange = (value: string | null): void => {
    if (value === 'none') {
      form.setFieldValue('startWeekday', null)
      return
    }

    const weekday = WeekdaySchema.safeParse(value)
    form.setFieldValue('startWeekday', weekday.success ? weekday.data : undefined)
  }

  return (
    <Select
      allowDeselect={false}
      data={WEEKDAY_OPTIONS}
      flex={1}
      label='Start Weekday'
      description='The day of the week the program should start on'
      searchable
      value={getWeekdayValue(form.values.startWeekday)}
      onChange={handleChange}
    />
  )
}
